// extracted by mini-css-extract-plugin
export var bottomCircle = "bJ_hj";
export var content = "bJ_b6";
export var description = "bJ_dd";
export var hide = "bJ_B";
export var icon = "bJ_bw";
export var image = "bJ_k";
export var imageContainer = "bJ_hn";
export var left = "bJ_bK";
export var nextYear = "bJ_hm";
export var right = "bJ_bY";
export var section = "bJ_j";
export var shrink = "bJ_hl";
export var title = "bJ_g";
export var topCircle = "bJ_hh";
export var wave = "bJ_gC";
export var waveContainer = "bJ_d2";
export var year = "bJ_hk";